import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// import login from '@/components/login'

const routes = [
  { path: '/', component: () => import('@/views/home/goto') },
  { path: '/home/view/:id', component: () => import('@/views/home/view') },
  { path: '/jump/:key', component: () => import('@/views/home/jump') },
  { path: '/app', component: () => import('@/views/home/appdownload') },
  // 首页部分
  { path: '/home/index', meta: { keepAlive: true }, component: () => import('@/views/home/index') },
  { path: '/home/staticPage/:code', component: () => import('@/views/home/staticPage') },
  // 商城部分
  { path: '/store/index', meta: { keepAlive: true }, component: () => import('@/views/store/storeIndex') },
  { path: '/store/addressEdit', component: () => import('@/views/store/addressEdit') },
  { path: '/store/addressList', component: () => import('@/views/store/addressList') },
  { path: '/store/diveshopList', meta: { keepAlive: true }, component: () => import('@/views/store/diveshopList') },
  { path: '/store/diveshop/:id', component: () => import('@/views/store/diveshop') },
  { path: '/store/orderList', component: () => import('@/views/store/orderList') },
  { path: '/store/orderInfo/:id', component: () => import('@/views/store/orderInfo') },
  { path: '/store/orderComment/:id', component: () => import('@/views/store/orderComment') },
  { path: '/store/globaldivecenterList', meta: { keepAlive: true }, component: () => import('@/views/store/globaldivecenterList') },
  { path: '/store/globalMydivecenterList', meta: { keepAlive: true }, component: () => import('@/views/store/globalMydivecenterList') },
  { path: '/store/globaldivecenter/:id', component: () => import('@/views/store/globaldivecenter') },
  { path: '/store/commodityList/:id', meta: { keepAlive: true }, component: () => import('@/views/store/commodityList') },
  { path: '/store/commodity/:id', component: () => import('@/views/store/commodity') },
  { path: '/store/studentList', component: () => import('@/views/store/studentList') },
  { path: '/store/studentEdit/:id', component: () => import('@/views/store/studentEdit') },
  // 教材资质部分
  { path: '/textbook/index', component: () => import('@/views/textbook/textbookIndex') },
  { path: '/textbook/textbook/:id', component: () => import('@/views/textbook/textbook') },
  { path: '/textbook/license', component: () => import('@/views/textbook/license') },
  { path: '/textbook/card', component: () => import('@/views/textbook/card') }, // 分享卡
  { path: '/textbook/licenseCard', component: () => import('@/views/textbook/licenseCard') },
  { path: '/textbook/licensePhysics', component: () => import('@/views/textbook/licensePhysics') },
  { path: '/textbook/crossCertification/:id', component: () => import('@/views/textbook/crossCertification') },
  { path: '/textbook/crossCertificationList', component: () => import('@/views/textbook/crossCertificationList') },
  { path: '/textbook/applicationTextbook', component: () => import('@/views/textbook/applicationTextbook') },
  { path: '/textbook/applicationTextbookList', component: () => import('@/views/textbook/applicationTextbookList') },
  { path: '/textbook/teachingProgressList', component: () => import('@/views/textbook/teachingProgressList') },
  { path: '/textbook/teachingProgressOne/:id', component: () => import('@/views/textbook/teachingProgressOne') },
  { path: '/textbook/teachingProgressAdd/:id', component: () => import('@/views/textbook/teachingProgressAdd') },
  // 用户，个人中心部分
  { path: '/users/index', component: () => import('@/views/users/usersIndex') },
  { path: '/users/bindSSI', component: () => import('@/views/users/bindSSI') },
  { path: '/users/regPhone', component: () => import('@/views/users/regPhone') },
  { path: '/users/changeIcon', component: () => import('@/views/users/changeIcon') },
  { path: '/users/job', component: () => import('@/views/users/job') },
  { path: '/users/updateinfo', component: () => import('@/views/users/updateinfo') },
  { path: '/users/help', component: () => import('@/views/users/help') },
  { path: '/loginCallback', component: () => import('@/views/users/loginCallback') },
  // 活动部分
  { path: '/activity/group', component: () => import('@/views/activity/group') },
  { path: '/activity/groupOrder', component: () => import('@/views/activity/groupOrder') },
  { path: '/activity/groupReg', component: () => import('@/views/activity/groupReg') },
  { path: '/activity/groupTeams', component: () => import('@/views/activity/groupTeam') },
  { path: '/activity/groupTeamCreate', component: () => import('@/views/activity/groupTeamCreate') },
  { path: '/activity/groupCheck', component: () => import('@/views/activity/groupCheck') },

  { path: '/activity/raffle', component: () => import('@/views/activity/raffle') },
  { path: '/activity/raffleReg', component: () => import('@/views/activity/raffleReg') },
  { path: '/activity/raffleList', component: () => import('@/views/activity/raffleList') },

  { path: '/activity/cardApprove', component: () => import('@/views/activity/cardApprove') },
  { path: '/activity/liveDraw/:id', component: () => import('@/views/activity/liveDraw') }
]

export default new Router({
  routes: routes,
  mode: 'history'
})
